module.exports = __webpack_public_path__ + "components/rewards/support/static/logo-ddfee321c14fafc4bf6b5411fe03a0e1.webp";